<template>
	<div class="default-component-wrapper">
		<div class="section-header">Interior Design Ideas</div>
		<div class="looks-wrapper">
			<div
				v-for="look of looks"
				:key="look._id"
				class="look image-wrapper"
				@click="handleLookClick(look)"
			>
				<img :src="look.thumbnail" alt="" />
				<div class="text">
					{{ look.name }}
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
	name: "DefaultComponent",
	components: {},
	data: () => ({}),
	computed: {
		...mapGetters(["looks"]),
	},
	async mounted() {
		// this.$router.push(`/catalog/${this.currentBook}`);
		this.fetchLooks();
	},
	destroyed() {},
	methods: {
		...mapActions(["fetchLooks"]),
		handleLookClick(look) {
			this.$router.push(`/?lookid=${look._id}`);
		},
	},
};
</script>

<style lang="scss" scoped>
.default-component-wrapper {
	padding: 1rem;
	max-width: 1440px;
	margin: 0 auto;

	@include custom-min(768px) {
		padding: 1.25rem;
	}
	.section-header {
		font-family: $heading-font;
		font-style: normal;
		font-weight: 400;
		font-size: 1.25rem;
		line-height: 140%;
		// text-align: center;
		margin-bottom: 2rem;
		width: 91%;

		@include custom-min(768px) {
			font-size: 2rem;
			margin-bottom: 3rem;
		}
	}
	.looks-wrapper {
		display: grid;
		grid-template-columns: 1fr;
		gap: 2rem;

		@include custom-min(768px) {
			grid-template-columns: 1fr 1fr;
		}

		@include custom-min(1024px) {
			grid-template-columns: 1fr 1fr 1fr;
		}

		.look {
			cursor: pointer;
			img {
				min-height: 275px;
				object-fit: cover;
				object-position: center center;
			}

			.text {
				font-size: 1.125rem;
				line-height: 1.375rem;
				width: 100%;
				padding: 1.25rem;
				font-weight: 700;

				@include custom-min(1024px) {
					font-size: 1.5rem;
				}
			}
		}
	}
}
</style>
